import * as actions from "../actionTypes";
import {
  GET_STUDENTS,
  ADD_STUDENT,
  UPDATE_STUDENT,
  DELETE_STUDENT,
} from "../api";
import client from "../apolloClient";
import { setEnrollments } from "./enrollmentActions.js";
import { setAttendanceModified } from "./loadingActions.js";

export const deleteStudent = (student_id) => async (dispatch, getState) => {
  try {
    const state = getState();
    // Find enrollments, grades, and payments related to the student
    const enrollments = state.enrollments.filter(
      (en) => en.student._id === student_id
    );
    // Get the IDs of the enrollments for the student
    const enrollmentIds = enrollments.map((en) => en._id);

    // Find attendances related to the enrollments
    const attendances = state.attendances.filter((at) =>
      enrollmentIds.includes(at.enrollment._id)
    );
    const grades = state.grades.filter((gr) => gr.student._id === student_id);
    const payments = state.paymentRecords.filter(
      (py) => py.student._id === student_id
    );

    // Dispatch actions to delete enrollments,attendances grades, and payments locally
    enrollments.forEach((enrollment) => {
      const action2 = {
        type: actions.DELETE_ENROLLMENT,
        payload: enrollment._id,
      };
      dispatch(action2);
    });
    attendances.forEach((attendance) => {
      const action5 = {
        type: actions.DELETE_ATTENDANCE,
        payload: attendance._id,
      };
      dispatch(action5);
    });

    grades.forEach((grade) => {
      const action3 = { type: actions.DELETE_GRADE, payload: grade._id };
      dispatch(action3);
    });

    payments.forEach((payment) => {
      const action4 = {
        type: actions.DELETE_PAYMENT_RECORD,
        payload: payment._id,
      };
      dispatch(action4);
    });
    await client.mutate({
      mutation: DELETE_STUDENT,
      variables: { input: student_id },
    });
    const action = {
      type: actions.DELETE_STUDENT,
      payload: student_id,
    };
    dispatch(action);
  } catch (error) {
    console.log(error);
  }
};

export const setStudents = () => async (dispatch) => {
  try {
    const { data } = await client.query({
      query: GET_STUDENTS,
      fetchPolicy: "no-cache",
    });
    const students = await data.students;
    let arrayOfEnrollments = [];
    students.forEach((student) => {
      if (student.enrollments && student.enrollments.length > 0) {
        student.enrollments.forEach((enrollment) => {
          arrayOfEnrollments = [...arrayOfEnrollments, enrollment];
        });
      }
    });
    if (arrayOfEnrollments.length > 0) {
      dispatch(setEnrollments(arrayOfEnrollments));
    } else {
      await dispatch(setAttendanceModified(false));
    }

    const action = { type: actions.SET_STUDENTS, payload: students };
    await dispatch(action);
  } catch (error) {
    console.log(error);
  }
};
export const setStudentsLocally = (students) => async (dispatch) => {
  try {
    let arrayOfEnrollments = [];
    students.forEach((student) => {
      if (student.enrollments && student.enrollments.length > 0) {
        student.enrollments.forEach((enrollment) => {
          arrayOfEnrollments = [...arrayOfEnrollments, enrollment];
        });
      }
    });
    if (arrayOfEnrollments.length > 0) {
      dispatch(setEnrollments(arrayOfEnrollments));
    }

    const action = { type: actions.SET_STUDENTS, payload: students };
    dispatch(action);
  } catch (error) {
    console.log(error);
  }
};
export const addStudent = (student) => async (dispatch) => {
  try {
    const { data } = await client.mutate({
      mutation: ADD_STUDENT,
      variables: { input: student },
    });
    const savedStudent = data.createStudent;
    savedStudent.enrollments = [];
    const action = { type: actions.ADD_STUDENT, payload: savedStudent };
    dispatch(action);
  } catch (error) {
    console.log(error);
  }
};

export const updateStudent = (student) => async (dispatch) => {
  try {
    const { data } = await client.mutate({
      mutation: UPDATE_STUDENT,
      variables: { input: student },
    });
    const updatedStudent = data.updateStudent;
    const action = { type: actions.UPDATE_STUDENT, payload: updatedStudent };
    dispatch(action);
  } catch (error) {
    console.log(error);
  }
};
export const updateStudentLocally =
  (updatedStudent) => async (dispatch, getState) => {
    try {
      const action = { type: actions.UPDATE_STUDENT, payload: updatedStudent };
      dispatch(action);
    } catch (error) {
      console.log(error);
    }
  };
